import request from "./axios";

function index(params) {
  return request({
    method: "get",
    url: `/zoom_records`,
    params: params
  });
}

function copyTranscript(id) {
  return request({
    method: "get",
    url: `/zoom_records/${id}/copy_transcript`
  });
}

const ZoomRecordsService = {
  index,
  copyTranscript
};

export default ZoomRecordsService;
